import { forwardRef, useEffect, useMemo, useRef, useState } from "react";
import ReactContentEditable from "react-contenteditable";

import { debounce } from 'lodash';

const DEBOUNCE_DELAY = 300

const ContentEditable = forwardRef(({ onChange, html: defaultValue, tagName: TagName, ...props }, ref) => {
  const [value, setValue] = useState(defaultValue)
  const [focus, setFocus] = useState(false)
  const onChangeRef = useRef(onChange)

  useEffect(() => {
    onChangeRef.current = onChange
  }, [onChange])

  const debouncedOnChange = useMemo(() => debounce(val => onChangeRef.current(val), DEBOUNCE_DELAY), [])

  useEffect(() => () => debouncedOnChange.cancel(), [debouncedOnChange])

  useEffect(() => {
    if (!focus) {
      setValue(defaultValue)
    }
  }, [defaultValue, focus])

  return <TagName ref={ref} {...props}>
    <ReactContentEditable
      onFocus={() => setFocus(true)}
      onBlur={() => setFocus(false)}
      onPaste={e => {
        const jsString = e.clipboardData.getData('text/plain')
        const htmlString = js2html(jsString)
        setValue(htmlString)
        onChange(htmlString)
        e.preventDefault()
      }}
      onChange={e => {
        setValue(e.target.value)
        debouncedOnChange(js2html(html2js(e.target.value)))
      }}
      html={value}
      tagName={'span'}
    />
  </TagName>
})

export default ContentEditable

export function js2html(jsString) {
  const text = document.createElement('div')
  text.innerText = jsString
  return text.innerHTML
}

export function html2js(htmlString) {
  const text = document.createElement('div');
  text.innerHTML = htmlString;
  document.body.appendChild(text);
  text.style.whiteSpace = 'pre';
  const result = text.innerText;
  document.body.removeChild(text);
  return result;
}
